const schema = require('../../../schema.json')

export default {
  namespaced: true,

  state: {
    schema,
    initials: 'BC',
  },
}
